import { defineComponent as _defineComponent } from 'vue'
import Navigation from "../../../NavigationContainer.vue";
import { ref, onMounted, reactive, onUpdated } from "vue";
import { useI18n } from "vue3-i18n";
import Loading from "@/components/home/Loading";
import ResponseData from "@/types/ResponseData";
import IssueSalesNoteDataService from "@/services/KDPIssueSalesNoteDataService";
import Alert from "@/components/scan/parts/Alert.vue";
import { useRouter } from "vue-router";
import { store } from "@/store/store";
import SalesNoteLinkNavigation from "../../../KDPSalesNoteLinkNavigationContainer.vue";
import SalesNoteHeaderNavigation from "../../../KDPSalesNoteHeaderNavigationContainer.vue";
import KDPSalesNote from "@/types/KDPSalesNote";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const router = useRouter();
const selectedDistMode = ref("0");
const txtDistCD = ref("");
const statusInfoList = reactive([]);
const selectedStatus = ref("all");
const selectedProdMMMode = ref("ASC");
const tblShowFlg = ref(false);
const btnCancelFlg = ref(false);
const btnCirculationFlg = ref(false);
const btnIssueFlg = ref(false);
const issueSalesNoteList = reactive([]);
const paramSalesNote = reactive([]);
const paramSalesNoteList = reactive([]);
const stTime = "08:00:00";
const endTime = "19:00:00";
const strTm = parseInt(stTime.replace(/:/g, ""));
const endTm = parseInt(endTime.replace(/:/g, ""));
const statusData = reactive({distributorName: "",scan_kdp_approval:[]});
const checkInfoList = reactive([]);
const menuCD = ref("");

onMounted(function () {
  // Status情報取得
  getStatusList();
  store.dispatch("setParamKDPSalesNoteList", null);
  menuCD.value = store.getters.mainMenuCode;
  checkInfoList.splice(0);

  // issue sale note ボタンの有無
  chkTime();
  
  // 検索モード
  const searchInfo = store.getters.kdpSalesNoteSearchData || null;
  if (searchInfo != null && searchInfo.mode == 'Search') {
    
    txtDistCD.value = searchInfo.txtDistCD
    selectedDistMode.value = searchInfo.selectedDistMode
    selectedStatus.value = searchInfo.selectedStatus
    selectedProdMMMode.value = searchInfo.selectedProdMMMode

    store.dispatch("setKDPSalesNoteSearchData", null);
    tblShowFlg.value = true;
    getIssueSalesNoteList();
  }
});

/** Status情報取得 */
const getStatusList = () => {
  isLoading.value = true;
  statusInfoList.splice(0);

  // 二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";
  
  const data = {
    userId : store.getters.cognitoUserName
  }
  // Status情報取得
  IssueSalesNoteDataService.getKDPSalesNoteStatusList(data)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        statusInfoList.push({ status : "all", description : "View All"})
        for (let info of response.data) {
          statusInfoList.push(info);
        }
      }
      isLoading.value = false;
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err099");
      alertState.value = "error";
      isLoading.value = false;
    });
};

/** 検索ボタンイベント */
const goDetailSearch = () => {  
  checkInfoList.splice(0);
  var tblbodydiv = document.getElementById("tblbodydiv");
  if (tblbodydiv != null) {
    tblbodydiv.style.borderBottom = "";
  }
  if((txtDistCD.value.length) == 0 || (txtDistCD.value.length) < 6){
    alert(i18n.t("alt101"));
    txtDistCD.value="";
    (document.getElementById("txtDistCD") as HTMLInputElement).focus();
  }else{
    const specialChar = /[!@#$%^&'*+=;()_\-`~,.?":[\]{}|<>]/;
    const onlyLetter = /^[A-Za-z]{6}$/;
    if (specialChar.test(txtDistCD.value)) {
      alert(i18n.t("alt113"));
      txtDistCD.value="";
      (document.getElementById("txtDistCD") as HTMLInputElement).focus();
      return;
    } 
    else if (onlyLetter.test(txtDistCD.value) ) {
      alert(i18n.t("alt114"));
      txtDistCD.value="";
      (document.getElementById("txtDistCD") as HTMLInputElement).focus();
      return;
    }
    else{
      tblShowFlg.value = true;
      getIssueSalesNoteList();
    }
  }
}

/** Get Status List */
const getIssueSalesNoteList = () => {
  isLoading.value = true;
  issueSalesNoteList.splice(0);

  // ボタンの有効
  btnCancelFlg.value = false;
  btnCirculationFlg.value = false;
  btnIssueFlg.value = false;

  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  // パラメータ
  const distCDList = {
    txtDistCD : txtDistCD.value,
    distMode : selectedDistMode.value,
    status : selectedStatus.value,
    prodMMMode : selectedProdMMMode.value,
    menuCD : menuCD.value,
    userId : store.getters.cognitoUserName
  }  

  // get Status Data
  IssueSalesNoteDataService.getKDPIssueSalesNoteInfoList(distCDList)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        for (let info of response.data) {
          if (info.status == "1") {
            info.chkCheck = true;
          }
          if (info.issueDate != null && info.issueDate != '') {
            info.issueDate = info.issueDate.slice(0, 4) + '/' + info.issueDate.slice(4, 6) + '/' + info.issueDate.slice(6, 8)
          }
          if (info.smcApproveDate != null && info.smcApproveDate != '') {
            info.smcApproveDate = info.smcApproveDate.slice(0, 4) + '/' + info.smcApproveDate.slice(4, 6) + '/' + info.smcApproveDate.slice(6, 8)
          }
          if (info.distributorApproveDate != null && info.distributorApproveDate != '') {
            info.distributorApproveDate = info.distributorApproveDate.slice(0, 4) + '/' + info.distributorApproveDate.slice(4, 6) + '/' + info.distributorApproveDate.slice(6, 8)
          }
          issueSalesNoteList.push(info);
        }

        // issue sale note ボタンの有無
        chkTime();
      } else {
        btnCancelFlg.value = true;
        btnCirculationFlg.value = true;
        btnIssueFlg.value = true;
      }
      isLoading.value = false;
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err100");
      alertState.value = "error";
      isLoading.value = false;
    });
};

/** 一覧のチェックボックスクリックイベント */
const chkCheckEvent = (info : any) => {
  if (info.isChecked) {
    const deleteData = checkInfoList.findIndex((i: { id: number; }) => i.id === info.id)
    checkInfoList.splice(deleteData,1)
  } else {
    checkInfoList.push(info);
  }
  if (checkInfoList.length > 0) {
    const checkedIssueList = checkInfoList.filter((i: { status: string; }) => ["0","7"].includes(i.status));
    const checkedCancelList = checkInfoList.filter((i: { status: string; }) => ["2","3","4","5","6"].includes(i.status));
    const checkedCirculationList = checkInfoList.filter((i: { status: string; }) => ["2"].includes(i.status));
    if (checkedIssueList.length > 0){
      btnIssueFlg.value = false;
    }
    else{
      btnIssueFlg.value = true;
    }
    if (checkedCirculationList.length > 0){
      btnCirculationFlg.value = false;
    }
    else{
      btnCirculationFlg.value = true;
    }
    if (checkedCancelList.length > 0 ){
      btnCancelFlg.value = false;
    }
    else{
      btnCancelFlg.value = true;
    }
  }
  else{
    btnIssueFlg.value = false;
    btnCancelFlg.value = false;
    btnCirculationFlg.value = false;
  }
  chkTime();
};

/** 19時から翌日8時までIssue Sales Noteは押せないように制御 */
const chkTime = () => {
  const jpTime = new Date(new Date().toLocaleString("en-us", { timeZone : 'Asia/Tokyo'}));
  const curTime = parseInt(
    String(jpTime.getHours()).padStart(2,"0") +
    String(jpTime.getMinutes()).padStart(2, "0") +
    String(jpTime.getSeconds()).padStart(2,"0")
  )

	if (curTime < strTm || curTime > endTm){
    btnIssueFlg.value = true;
	}
};

/** 一覧のpdfアイコン表示イベント */
const showPDFFile = (info : any) => {
  var subFolderPDF = info.pdfCreatedYM + "_" + info.salesNo + "_" + info.parentDistributorCode + "_" + info.distributorCode + "_" + info.seqNo
  var pdfFileName = subFolderPDF + "/" + info.salesNo + ".pdf"

  isLoading.value = true;
  const data = { 
    'fileName' : pdfFileName,
    'userId' : store.getters.cognitoUserName
  };

  IssueSalesNoteDataService.getPreSignedUrl(data)
    .then((response: ResponseData) => {
      isLoading.value = false;
      if (response.data == '') {
        alert(i18n.t("alt110"))
      } else {
        window.open(response.data)?.focus()
      }
    });
};

/** 一覧のstatusリンククリックイベント */
const showModal = (info : any) => {
  statusData.distributorName = "";
  statusData.scan_kdp_approval = [];
  isLoading.value = true; 
  const dataLambda = { 
    functionName : "getDistributorName",
    distCd : info.parentDistributorCode 
  };
  IssueSalesNoteDataService.getDistributorName(dataLambda)
  .then((response) => {
    statusData.distributorName = response.data.distributor_name;
    const data = { 
      saleNo : info.salesNo,
      seqNo : info.seqNo,
      userId : store.getters.cognitoUserName
    };
    IssueSalesNoteDataService.getStatusDetail(data)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        statusData.scan_kdp_approval = response.data.scan_kdp_approval;
        isLoading.value = false; 
      }
    })
    .catch((error: ResponseData) => {
      alertMessage.value = i18n.t("err117");
      alertState.value = "error";
      isLoading.value = false; 
    });
  })
  .catch((error: ResponseData) => {
    alertMessage.value = i18n.t("err109");
    alertState.value = "error";
    isLoading.value = false; 
  });

};

const CancelSaleNote = () => {
  var chkFlg = false;
  var checkedList;
  chkFlg = issueSalesNoteList.some((i: { isChecked: boolean; }) => i.isChecked === true);
  if (!chkFlg) {
    alert(i18n.t("alt102"));
  } else {
    const isCheckedStatusFor07 = checkInfoList.filter((i: { status: string; }) => ["0","7"].includes(i.status));
    if (isCheckedStatusFor07.length >0) {
      alert(i18n.t("alt112"));
      return;
    }
    checkedList = issueSalesNoteList.filter((i: { isChecked: boolean; }) => i.isChecked === true)
    sendParam(checkedList);
    store.dispatch("setKDPSalesNoteScreen", 'KDPIssueSalesNote');
    router.push('/KDPCancelSalesNote');
  }
};

const IssueSaleNote = () => {
  var chkFlg = false;
  var checkedList;
  chkFlg = issueSalesNoteList.some((i: { isChecked: boolean; }) => i.isChecked === true);
  if (!chkFlg) {
    alert(i18n.t("alt102"));
  } else {
    checkedList = issueSalesNoteList.filter((i: { isChecked: boolean; }) => i.isChecked === true)
    const isCheckedStatusFor07 = checkInfoList.filter((i: { status: string; }) => ["2","3","4","5","6"].includes(i.status));
    const isCheckedStatusFor7 = checkInfoList.filter((i: { status: string; }) => ["7"].includes(i.status));
    if (isCheckedStatusFor07.length >0) {
      alert(i18n.t("alt111"));
      return;
    }
    else if (isCheckedStatusFor7.length >0) {
      if (!confirm(i18n.t("cnf016"))){
        return;
      }
    }
    sendParam(checkedList);
    updateKDPDataAndMailSend();
  }
};

// 確認メッセージ表示のため
const updateKDPDataAndMailSend = () => {
    paramSalesNoteList.splice(0);
    paramSalesNoteList.push(...store.getters.paramKDPSalesNoteList);
    
    const data = {
      paramKDPSalesNoteList : paramSalesNoteList,
      userId : store.getters.cognitoUserName
    }  
    isLoading.value = true;
    IssueSalesNoteDataService.checkAndUpdateKDPIssueSalesNoteInfoList(data)
      .then((response: ResponseData) => {
        if (response.data.length !== 0) {
          isLoading.value = false;
          alert(i18n.t("suc046"));
          goDetailSearch();
        } 
      })
      .catch((e: Error) => {
        alert(i18n.t("alt107"));
        isLoading.value = false;
      }); 
};

/** Circulationボタンクリックイベント */
const Circulation = () => {
  var chkFlg = false;
  var isCheckedOK = false;
  var checkedList;
  chkFlg = issueSalesNoteList.some((i: { isChecked: boolean; }) => i.isChecked === true);
  checkedList = issueSalesNoteList.filter((i: { isChecked: boolean; }) => i.isChecked === true)
  isCheckedOK = checkedList.every((i: { status: string; }) => i.status === '2');

  if (!chkFlg) {
    alert(i18n.t("alt102"));
  } else {
    if (!isCheckedOK) {
      alert(i18n.t("alt103").replaceAll("{status}", '(' + statusInfoList.find((i: { status: string; }) => i.status === '2')?.description + ')'));
      return;
    }

    sendParam(checkedList);
    store.dispatch("setKDPSalesNoteScreen", 'KDPIssueSalesNote');
    router.push('/KDPTermsofService');
  }
};

/** 次の画面で使うためstoreにパラメータの保存 */
const sendParam = (checkedList : any) => {
  paramSalesNote.splice(0);
  var salesNoteInfo : KDPSalesNote;
  var searchInfo = {};

  for (let param of checkedList) {
    salesNoteInfo = {
      salesNo : param.salesNo,
      prodYM : param.productionYM,
      seqNo : param.seqNo,
      parentCD : param.parentDistributorCode,
      distCD : param.distributorCode,
      factory : param.factory_name,
      status : param.status,
      statusDescription : statusInfoList.find((i: { status: string; }) => i.status === param.status)?.description,
      issueDate : param.issueDate,
      smcApproveDate : param.smcApproveDate,
      distributorApproveDate : param.distributorApproveDate,
      productionType : param.productionType,
      drafterId : param.drafterId,
      approverId : param.approverId,
      pdfFlg : param.pdfFlg,
      pdfCreatedYM: param.pdfCreatedYM
    }
    paramSalesNote.push(salesNoteInfo);
  }
  
  searchInfo = {
    mode: '',
    selectedDistMode: selectedDistMode.value,
    txtDistCD: txtDistCD.value,
    selectedStatus: selectedStatus.value,
    selectedProdMMMode: selectedProdMMMode.value
  }
  store.dispatch("setParamKDPSalesNoteList", paramSalesNote);
  store.dispatch("setKDPSalesNoteSearchData", searchInfo);
};

onUpdated(function () {
  try {
    var dataHeight = document.getElementById("tbltbody")?.clientHeight;
    if (dataHeight != 0) {
      var tableHeight = document.getElementById("tblbodydiv")?.clientHeight;
      if (dataHeight > tableHeight) {
        document.getElementById("tblbodydiv").style.width = "100%";
        document.getElementById("tblbodydiv").style.borderBottom = "#ccc solid 0.5px";
      } else {
        document.getElementById("tblbodydiv").style.width = "calc(100% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
});

const __returned__ = { isLoading, alertMessage, alertState, i18n, router, selectedDistMode, txtDistCD, statusInfoList, selectedStatus, selectedProdMMMode, tblShowFlg, btnCancelFlg, btnCirculationFlg, btnIssueFlg, issueSalesNoteList, paramSalesNote, paramSalesNoteList, stTime, endTime, strTm, endTm, statusData, checkInfoList, menuCD, getStatusList, goDetailSearch, getIssueSalesNoteList, chkCheckEvent, chkTime, showPDFFile, showModal, CancelSaleNote, IssueSaleNote, updateKDPDataAndMailSend, Circulation, sendParam, Navigation, Loading, Alert, SalesNoteLinkNavigation, SalesNoteHeaderNavigation }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})